import React, { useState } from 'react';
import { useAuth } from '../context/AuthContext';
import './Login.css';

export default function Login() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const { login } = useAuth();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      await login(email, password);
    } catch (err) {
      setError('Invalid credentials. Please check your email and password.');
    }
    setLoading(false);
  };

  return (
    <div className="login-page">
      <div className="login-bg-pattern" />
      <div className="login-container">
        <div className="login-logo-area">
          <div className="login-logo-icon">⚗️</div>
          <div className="login-logo-text">
            <span className="login-logo-main">Wohler</span>
            <span className="login-logo-sub">.chemical</span>
          </div>
          <div className="login-tagline">Research Compound Intelligence Platform</div>
        </div>

        <div className="login-card">
          <div className="login-card-header">
            <div className="login-secure-badge">
              <span className="login-secure-icon">🔒</span>
              Restricted Access — Authorized Researchers Only
            </div>
            <h2>Sign In to Research Portal</h2>
            <p>Access is limited to Wohler Chemical research team and institutional partners.</p>
          </div>

          {error && (
            <div className="login-error">
              <span>⚠️</span> {error}
            </div>
          )}

          <form onSubmit={handleSubmit} className="login-form">
            <div className="login-field">
              <label htmlFor="email">Email Address</label>
              <input
                id="email"
                type="email"
                value={email}
                onChange={e => setEmail(e.target.value)}
                placeholder="researcher@institution.edu"
                required
                autoComplete="email"
              />
            </div>
            <div className="login-field">
              <label htmlFor="password">Password</label>
              <input
                id="password"
                type="password"
                value={password}
                onChange={e => setPassword(e.target.value)}
                placeholder="••••••••••••"
                required
                autoComplete="current-password"
              />
            </div>
            <button type="submit" className="login-btn" disabled={loading}>
              {loading ? (
                <span className="login-spinner">Authenticating...</span>
              ) : (
                'Access Research Portal →'
              )}
            </button>
          </form>

          <div className="login-footer-note">
            <p>To request access, contact: <strong>research@wohlerchemical.com</strong></p>
          </div>
        </div>

        <div className="login-disclaimer">
          <strong>Research Use Only.</strong> All compounds listed are for laboratory research purposes only. 
          Not for human consumption. Information is provided for scientific research and educational purposes.
        </div>
      </div>
    </div>
  );
}